import {
  memo, useCallback, useMemo,
} from 'react';
import { useSelector } from 'react-redux';
import { createUseStyles } from 'react-jss';

import * as Modal from 'components/common/modal/Modal';
import Button from 'components/Button';

import { useDispatcher } from 'store/utils/redux/hooks';
import * as invitationStore from 'store/nodes/invitation';
import * as cardStore from 'store/nodes/card';

import { ReactComponent as CloseIcon } from './assets/icon-close-button.svg';

import Respond from './elements/Respond';
import Info from './elements/Info';
import Note from './elements/Note';

type InvitationProps = {};

const Invitation = (props: InvitationProps) => {
  const classes = useStyles();
  const dispatcher = useDispatcher();

  const isShareableLink = useSelector(cardStore.selectors.isShareableLink);
  const isOpen = useSelector(invitationStore.selectors.isOpen);
  const step = useSelector(invitationStore.selectors.getStep);

  const marginTop = useMemo(() => {
    if (step === 'attending') {
      return '12rem';
    }
    if (step === 'info' && isShareableLink) {
      return '7.2rem';
    }
    if (step === 'info' && !isShareableLink) {
      return '16rem';
    }
    if (step === 'note') {
      return '6.4rem';
    }
    return '12rem';
  }, [step]);

  const isLoading = useSelector(invitationStore.selectors.isLoading(step || 'attending'));

  const handleClose = useCallback(() => {
    dispatcher.invitation.close();
  }, []);

  return (
    <Modal.Item
      visible={isOpen}
      hAlign="center"
      vAlign="flex-start"
      onOutsideClick={handleClose}
    >
      <div className={classes.Invitation} style={{ marginTop }}>
        <div className={classes.body}>
          <Button
            width={32}
            height={32}
            type="button-icon"
            className={classes.buttonClose}
            isDisabled={isLoading}
            onPress={handleClose}
          >
            <CloseIcon fill="#3F3F3F" />
          </Button>
          {step === 'attending' && (
            <Respond />
          )}
          {step === 'info' && (
            <Info />
          )}
          {step === 'note' && (
            <Note />
          )}
        </div>
      </div>
    </Modal.Item>
  );
};

const useStyles = createUseStyles({
  Invitation: {
    fontFamily: 'Avenir Next, sans-serif',
    fontWeight: 400,
    position: 'relative',
    borderRadius: '1.3rem',
    width: '100%',
    maxWidth: '34rem',
    background: '#fafafa',
    boxShadow: '0 0 5.2rem rgba(0,0,0,.35)',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    padding: '2.4rem',
    alignItems: 'stretch',
  },
  buttonClose: {
    '&': {
      position: 'absolute',
      top: '2.3rem',
      right: '2rem',
    },
    '& svg': {
      width: '2.4rem',
      height: '2.4rem',
    },
  },
});

export default memo(Invitation);
